import React, { useState, useEffect, useMemo } from "react";
import Loader from "../Loader/Loader";
import useApiLoader from "../../Utils/useApiLoader";
import CustomSelect from "../Common/CustomSelect";
import Input from "../Common/CustomInput";
import { FaPlus, FaMinus } from "react-icons/fa";
import api from "../../setupMiddleware";
import { hasPermission, isAdmin } from "../../Utils/auth";
import { ToastContainer, toast, Bounce } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Textarea from "../Common/Textarea";
import { useParams } from "react-router-dom";
import { formatCurrency } from "../../Utils/getUserUtitls";

const salaryTypeOptions = [
  { label: "Allowance", value: "Allowance" },
  { label: "Deduction", value: "Deduction" },
];

const EditSalary = () => {
  const loading = useApiLoader();
  const navigate = useNavigate();
  const { id } = useParams();
  const [empData, setEmpData] = useState([]);
  const [fieldErrors, setFieldErrors] = useState({});
  const [rows, setRows] = useState([
    { salaryType: "", amount: "", description: "" },
  ]);

  const [salaryData, setSalaryData] = useState({
    user_id: 0,
    month: new Date().getMonth(),
    year: new Date().getFullYear(),
    monthly_salary: 0,
    basic_salary: 0,
    hra: 0,
    ta: 0,
    location_id: 0,
    deductions: [],
    earnings: [],
  });

  const empOptions =
    empData.length > 0 &&
    empData.map((emp) => ({
      label: emp.employee_name,
      value: emp.id,
    }));

  const currency = salaryData?.location_id === 1 ? "AED" : "₹";

  const handleChange = (index, field, value) => {
    const updated = [...rows];
    updated[index][field] = value;
    setRows(updated);
  };

  const addRow = () => {
    setRows([...rows, { salaryType: "", amount: "", description: "" }]);
  };

  const removeRow = (index) => {
    setRows(rows.filter((_, i) => i !== index));
  };

  // calculate totals with useMemo
  const { totalExtraAllowances, totalExtraDeductions, netSalary } =
    useMemo(() => {
      const allowances = rows
        .filter((r) => r.salaryType === "Allowance" && r.amount)
        .map((r) => Number(r.amount) || 0);
      const deductions = rows
        .filter((r) => r.salaryType === "Deduction" && r.amount)
        .map((r) => Number(r.amount) || 0);

      const totalExtraAllowances = allowances.reduce((sum, a) => sum + a, 0);
      const totalExtraDeductions = deductions.reduce((sum, d) => sum + d, 0);

      const totalDeductions = salaryData?.deductions.reduce(
        (sum, item) => sum + Number(item.amount),
        0
      );
      const totalEarings = salaryData?.earnings.reduce(
        (sum, item) => sum + Number(item.amount),
        0
      );

      console.log(totalDeductions, totalEarings);

      const netSalary =
        Number(salaryData.monthly_salary || 0) +
        totalExtraAllowances -
        totalExtraDeductions -
        Number(totalDeductions) +
        Number(totalEarings || 0);

      return { totalExtraAllowances, totalExtraDeductions, netSalary };
    }, [rows, salaryData]);

  // Employee select → fetch salary breakdown
  const getSalaryDetails = async (op) => {
    try {
      const res = await api.get(`/api/salaries/${id}`);
      if (res && res.status === 200) {
        const data = res.data?.salary;
        const earnings = [];
        const deductions = [];

        data?.deductions?.forEach((item) => {
          if (item.type === "earnings") earnings.push(item);
          else if (item.type === "deductions") deductions.push(item);
        });

        setSalaryData({
          user_id: data.user_id,
          month: data.month,
          year: data.year,
          monthly_salary: (
            parseFloat(data.basic_salary) +
            parseFloat(data.hra) +
            parseFloat(data.ta)
          ).toFixed(2),
          basic_salary: data.basic_salary,
          hra: data.hra,
          ta: data.ta,
          deductions: deductions,
          earnings: earnings,
          location_id: data.user.location_id,
          net_salary: data.net_salary,
          employee_name: data.user.first_name + " " + data.user.last_name,
          designation: data.user.designation.title,
        });
      }
    } catch (err) {
      console.error(err);
    }
  };

  console.log(salaryData);

  const handleSubmit = async () => {
    const allowances = rows
      .filter((r) => r.salaryType === "Allowance")
      .map((r) => ({
        salary_id: id,
        type: "earnings",
        amount: Number(r.amount),
        description: r.description,
      }));

    const deductions = rows
      .filter((r) => r.salaryType === "Deduction")
      .map((r) => ({
        salary_id: id,
        type: "deductions",
        amount: Number(r.amount),
        description: r.description,
      }));

    const combinedDeductionsArray = [
      ...deductions,
      ...allowances,
      ...salaryData?.earnings,
      ...salaryData?.deductions,
    ];

    const payload = {
      salary: {
        id: id,
        user_id: salaryData.user_id,
        month: salaryData.month,
        year: salaryData.year,
        basic_salary: salaryData.basic_salary,
        hra: salaryData.hra,
        ta: salaryData.ta,
        deductions: combinedDeductionsArray,
        net_salary: netSalary,
      },
    };

    try {
      const res = await api.put(`/api/salaries/${id}`, payload);
      if (res && res.status === 200) {
        toast.success("Salary Updated!", {
          position: "top-left",
          autoClose: 5000,
          theme: "colored",
          transition: Bounce,
        });
        setTimeout(() => navigate("/payroll"), 1500);
      }
    } catch (err) {
      toast.error(err.response?.data?.errors?.salary[0] || "Error", {
        position: "top-left",
        autoClose: 5000,
        theme: "colored",
        transition: Bounce,
      });
      setFieldErrors(err.response?.data?.errors || {});
      window.scrollTo(0, 0);
    }
  };

  const hasViewPermission = hasPermission("view_employees");

  useEffect(() => {
    // if (isAdmin() || hasViewPermission) {
    getSalaryDetails();
    // }
  }, []);

  return (
    <>
      {loading && <Loader opacity={90} fullscreen />}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center w-full mx-auto px-4 py-3 gap-4">
        <p>
          <span className="block text-xl sm:text-2xl font-medium text-[#de2b26]">
            Generate Salary
          </span>
          <span className="block text-sm text-[#142b70]/50">
            Select Employee and view salary breakdown
          </span>
        </p>
      </div>

      <div className="w-full mx-auto px-4 py-3 relative">
        <div className="w-full mx-auto p-8 relative rounded-3xl bg-white border border-[#a48572]/10">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-4 mt-4 text-sm text-[#142b70]/80">
            {[
              { label: "Employee Name", value: salaryData?.employee_name },
              {
                label: "Designation",
                value: salaryData?.designation,
              },
            ].map((item, idx) => (
              <div
                key={idx}
                className="flex items-start gap-2 bg-[#de2b26]/5 border-l-2 border-[#de2b26] rounded-lg p-3"
              >
                <div className="flex flex-col leading-tight">
                  <span className="text-[11px] uppercase tracking-wide text-[#142b70]/60 font-medium">
                    {item.label}
                  </span>
                  <span className="text-sm text-[#142b70] font-semibold">
                    {item.value || "—"}
                  </span>
                </div>
              </div>
            ))}
          </div>
          {/* {salaryData.monthly_salary > 0 && ( */}
          <div className="mt-6">
            <h2 className="text-md font-bold text-[#142b70] mb-4">
              Income Details<span className="text-red-500">*</span>
            </h2>

            <div className="grid grid-cols-1 gap-6">
              {/* Earnings Table */}
              <div className="bg-white rounded-lg shadow border border-gray-200 overflow-hidden">
                <table className="w-full">
                  <thead className="bg-[#de2b26]/10">
                    <tr>
                      <th className="px-4 py-2 text-left font-medium text-[#142b70]">
                        Salary Breakdown
                      </th>
                      <th className="px-4 py-2 text-right font-medium text-[#142b70]">
                        Amount
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200 text-gray-800">
                    <tr>
                      <td className="px-4 py-3 text-sm">Basic Salary</td>
                      <td className="px-4 py-3 text-right text-sm">
                        {currency} {formatCurrency(salaryData?.basic_salary)}
                      </td>
                    </tr>
                    <tr>
                      <td className="px-4 py-3 text-sm">HRA</td>
                      <td className="px-4 py-3 text-right text-sm">
                        {currency} {formatCurrency(salaryData?.hra)}
                      </td>
                    </tr>
                    <tr>
                      <td className="px-4 py-3 text-sm">TA</td>
                      <td className="px-4 py-3 text-right text-sm">
                        {currency} {formatCurrency(salaryData?.ta)}
                      </td>
                    </tr>
                    <tr className="bg-[#de2b26]/10 text-[#142b70] font-semibold">
                      <td className="px-4 py-3">Gross Earnings:</td>
                      <td className="px-4 py-3 text-right">
                        {currency} {formatCurrency(salaryData?.monthly_salary)}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              {/* Allowance Table */}
              <div className="bg-white rounded-lg shadow border border-gray-200 overflow-hidden">
                <table className="w-full">
                  <thead className="bg-[#de2b26]/10">
                    <tr>
                      <th className="px-4 py-2 text-left font-medium text-[#142b70]">
                        Allowance
                      </th>
                      <th className="px-4 py-2 text-right font-medium text-[#142b70]">
                        Amount
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200 text-gray-800">
                    {salaryData?.earnings?.length > 0 ? (
                      salaryData?.earnings.map((sal, idx) => (
                        <tr key={idx}>
                          <td className="px-4 py-4">
                            <span className="font-medium text-sm">
                              {sal.description}
                            </span>
                          </td>
                          <td className="px-4 py-3 text-right text-sm">
                            {currency} {formatCurrency(sal?.amount)}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td className="px-4 py-4 text-center" colSpan={2}>
                          <span className="text-sm text-gray-400">
                            No Allowance
                          </span>
                        </td>
                      </tr>
                    )}
                    <tr className="bg-[#de2b26]/10 text-[#142b70] font-semibold">
                      <td className="px-4 py-3">Total Allowance:</td>
                      <td className="px-4 py-3 text-right">
                        {currency}{" "}
                        {salaryData?.earnings.length > 0
                          ? formatCurrency(
                              salaryData?.earnings.reduce(
                                (sum, item) => sum + Number(item.amount),
                                0
                              )
                            )
                          : "0.00"}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              {/* Deductions Table */}
              <div className="bg-white rounded-lg shadow border border-gray-200 overflow-hidden">
                <table className="w-full">
                  <thead className="bg-[#de2b26]/10">
                    <tr>
                      <th className="px-4 py-2 text-left font-medium text-[#142b70]">
                        Deductions
                      </th>
                      <th className="px-4 py-2 text-right font-medium text-[#142b70]">
                        Amount
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200 text-gray-800">
                    {salaryData?.deductions?.length > 0 ? (
                      salaryData?.deductions.map((sal, idx) => (
                        <tr key={idx}>
                          <td className="px-4 py-4">
                            <span className="font-medium text-sm">
                              {sal.description}
                            </span>
                          </td>
                          <td className="px-4 py-3 text-right text-sm">
                            {currency} {formatCurrency(sal?.amount)}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td className="px-4 py-4 text-center" colSpan={2}>
                          <span className="text-sm text-gray-400">
                            No Deductions
                          </span>
                        </td>
                      </tr>
                    )}
                    <tr className="bg-[#de2b26]/10 text-[#142b70] font-semibold">
                      <td className="px-4 py-3">Total Deductions:</td>
                      <td className="px-4 py-3 text-right">
                        {currency}{" "}
                        {salaryData?.deductions.length > 0
                          ? formatCurrency(
                              salaryData?.deductions.reduce(
                                (sum, item) => sum + Number(item.amount),
                                0
                              )
                            )
                          : "0.00"}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            {/* Dynamic deductions and allowance */}
            <div className="flex flex-col flex-grow gap-6 w-full mb-8">
              <h2 className="text-md font-bold text-[#142b70] mt-8 -mb-2">
                Add Allowance / Deductions:
              </h2>
              {rows.map((row, index) => (
                <div key={index} className="flex items-center gap-4">
                  <div className="flex w-full gap-4">
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-1 gap-3 items-center w-[30%]">
                      <CustomSelect
                        options={salaryTypeOptions}
                        value={row.salaryType}
                        placeholder="Salary Type"
                        width="w-full"
                        height="h-[46px]"
                        fontSize="14px"
                        onChange={(option) =>
                          handleChange(index, "salaryType", option.value)
                        }
                      />
                      <Input
                        type="number"
                        placeholder="Amount"
                        value={row.amount}
                        onChange={(e) =>
                          handleChange(index, "amount", e.target.value)
                        }
                      />
                    </div>
                    <div className="w-[70%]">
                      <Textarea
                        type="text"
                        placeholder="Description"
                        value={row.description}
                        onChange={(e) =>
                          handleChange(index, "description", e.target.value)
                        }
                      />
                    </div>
                  </div>

                  <div className="flex gap-2 justify-end md:justify-center">
                    {rows.length > 1 && (
                      <div
                        className="border rounded p-2 bg-red-500/10 cursor-pointer"
                        onClick={() => removeRow(index)}
                      >
                        <FaMinus className="text-red-500" size={10} />
                      </div>
                    )}
                    {index === rows.length - 1 && (
                      <div
                        className="border rounded p-2 bg-[#de2b26]/10 cursor-pointer"
                        onClick={addRow}
                      >
                        <FaPlus
                          className="text-[#de2b26] cursor-pointer"
                          size={10}
                        />
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>

            {/* Net Payable */}
            <div className="bg-white mt-6 rounded-lg border border-gray-200 shadow p-4 flex items-center justify-between">
              <div>
                <p className="text-md font-semibold text-[#de2b26]">
                  Total Net Payable
                </p>
                <p className="text-sm text-gray-500">
                  Gross Earnings – Total Deductions
                </p>
              </div>
              <div>
                <p className="text-2xl font-bold text-[#142b70]">
                  {currency} {formatCurrency(netSalary.toFixed(2))}
                </p>
              </div>
            </div>
          </div>
          {/* )} */}

          <div className="flex justify-end items-center mt-6">
            <button
              className="px-10 py-3.5 rounded-md bg-[#de2b26] text-white font-medium"
              onClick={handleSubmit}
            >
              Update Salary
            </button>
          </div>
        </div>
      </div>
      <ToastContainer />
    </>
  );
};

export default EditSalary;
